
import { RSVPFlowState, EventData, GuestData } from '../types';
import { GuestSelectionStep } from './steps/GuestSelectionStep';
import { VerificationStep } from './steps/VerificationStep';
import { DateTimeSelectionStep } from './steps/DateTimeSelectionStep';
import { FeedbackStep } from './steps/FeedbackStep';
import { SelfieStep } from './steps/SelfieStep';
import { SuccessStep } from './steps/SuccessStep';

interface RSVPStepContainerProps {
  currentState: RSVPFlowState;
  eventData: EventData;
  availableGuests: GuestData[];
  respondedGuests: GuestData[];
  inProgressGuests: GuestData[];
}

export const RSVPStepContainer = ({ 
  currentState,
  eventData,
  availableGuests,
  respondedGuests,
  inProgressGuests
}: RSVPStepContainerProps) => {
  // Render the appropriate step based on current state
  const renderStep = () => {
    switch (currentState) {
      case 'initial':
      case 'guest_selection':
        // Handle both initial and guest_selection with the same component
        return <GuestSelectionStep />;
      case 'verification':
        return <VerificationStep />;
      case 'date_selection':
        // Use the DateTimeSelectionStep for the date_selection state
        return <DateTimeSelectionStep />;
      case 'feedback':
        return <FeedbackStep />;
      case 'selfie':
        return <SelfieStep />;
      case 'success':
        return <SuccessStep />;
      default:
        return <div>Unknown state</div>;
    }
  };

  return (
    <div className="max-w-2xl mx-auto w-full h-full flex flex-col">
      {renderStep()}
    </div>
  );
};
